export default (value: number, min: number, max: number): boolean => value >= min && value <= max
